import React from 'react';
import BuildAppNavigationProduct from './BuildAppNavigationProduct';
import styles from './BuildAppNavigation.module.scss';

export default function BuildAppNavigation({ productList, selectClicked }) {
  const productFamily = productList?.productList[0];

  if (!productFamily) {
    return <></>;
  }

  let products = productFamily.Children || [];

  return (
    <div className={styles.buildAppNavigation}>
      <div className={styles.list}>
        {products.map((product) => (
          <BuildAppNavigationProduct
            key={product?.ProductId}
            product={product}
            selectClicked={selectClicked}
          />
        ))}
      </div>
    </div>
  );
}
